import React, {useEffect} from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import {MILLISECOND_IN_SECOND} from '../../../constants/common';
import {startInterval} from '../../../helpers/interval.js';

import styles from './ad-slot.module.css';

/* Global variable: todo: get data from API */
const {platform} = window.Site.targeting;

function AdSlot({className, slot, slotMapping}) {

  const {targeting} = window.Site;
  const currentSlot = slotMapping?.[platform] || slot;

  useEffect(() => {
    if (currentSlot?.adfoxParams) {
      const newSlot = {
        ...currentSlot.adfoxParams,
        containerId: currentSlot?.code || currentSlot.adfoxParams.container,
        params: {
          ...currentSlot.adfoxParams.params,
          ...window.Site.adFoxParams,
          pk: [
            (targeting.category || []).join(' '),
            (targeting.tags || []).join(' '),
            targeting.attr_sponsored_by || '',
            targeting.attr_content_type || ''
          ].filter(Boolean).join(' '),
          pke: '1'
        }
      };

      window.yaContextCb?.push(() => window.Ya?.adfoxCode.create(newSlot));

      if (currentSlot.reloadInterval && currentSlot.containerId) {
        startInterval(() => window.Ya?.adfoxCode?.reload(currentSlot.containerId, {onlyIfWasVisible: false}),
          Number(currentSlot.reloadInterval) * MILLISECOND_IN_SECOND);
      }
    }
  }, []);

  if (!currentSlot) {
    return null;
  }

  return (
    <aside
      className={clsx(styles.root, {
        [styles[className]]: className
      })}
      data-label='Реклама'
    >
      <div
        id={currentSlot.code}
        className={styles.advert}
      />
    </aside>
  );
}

AdSlot.defaultProps = {
  className: '',
  slot: null,
  slotMapping: {}
};

AdSlot.propTypes = {
  className: PropTypes.string,
  slot: PropTypes.object,
  slotMapping: PropTypes.object
};

export default AdSlot;
